document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.badge').forEach((badge) => {
        const text = badge.textContent.trim().toLowerCase();
        if (text === 'sale') {
            badge.classList.add('sale');
        } else if (text === 'sold out') {
            badge.classList.add('sold-out');
        }
    });
});